import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { Grid } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const DrawingVersionColumn = ({ data }: Props) => {
	const {
		state: { dataDrawingSelected },
	} = useWorkOrderModalsContext();
	if (data.id === -1) {
		return (
			<Grid
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid item style={{ alignItems: "center", justifyContent: "center" }}>
					{dataDrawingSelected?.Version}
				</Grid>
			</Grid>
		);
	} else if (data.id !== -1) {
		return <>{data?.Version}</>;
	} else return <></>;
};
